import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { TypedMemo } from '../../common/types';
import { PublishedStep } from './usePublishedSteps';
import styles from './SMLPublishedStepRow.module.scss';

interface SMLPublishedStepRowProps {
  step: PublishedStep;
}

/** One thing worth doing, and the way to the place that does it. */
const SMLPublishedStepRowComponent: React.FC<SMLPublishedStepRowProps> = ({ step }) => (
  <button type="button" className={styles.row} onClick={step.onClick}>
    <span className={clsx(styles.icon, step.isWarning === true && styles.iconWarning)}>
      <FontAwesomeIcon icon={step.icon} />
    </span>
    <span className={styles.text}>
      <span className={clsx(styles.title, step.isWarning === true && styles.titleWarning)}>{step.title}</span>
      <span className={styles.description}>{step.description}</span>
    </span>
    <FontAwesomeIcon icon={faChevronRight} className={styles.chevron} />
  </button>
);

export const SMLPublishedStepRow = TypedMemo(SMLPublishedStepRowComponent);
